/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import baustein from "baustein";
import rothko from "modules/rothko";
import template from "templates/modules/product/related_products_section";

export default baustein.register("related-products-more-from-designer", {
    template,

    /**
     * fetches and renders the lazy loaded tabbed section
     * However, since we're not rendering the `is` property,
     * the tabbed section will no longer be a baustein component
     */
    fetchAndRender() {
        const { slug, uid } = this.options;

        rothko
            .fetch("modules/product/related_products_more_from_designer", { slug, uid })
            .then(data => {
                this.setRenderContext({
                    section: data
                });
            });
    }
});

